// extracted by mini-css-extract-plugin
export default {"notificationContainer":"NotificationProvider_notificationContainer__ezStq"};